module.exports = __webpack_public_path__ + "img/fuwu1.824d4a8.png";